import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import "./Select.scss";
export var Select = function Select(a) {
  var b = a.name,
      c = a.label,
      d = a.options,
      e = a.min,
      f = a.max,
      g = a.step,
      h = a.className,
      i = a.value,
      j = void 0 === i ? "" : i,
      k = _objectWithoutProperties(a, ["name", "label", "options", "min", "max", "step", "className", "value"]);

  b || (b = c.toLowerCase());
  return /*#__PURE__*/React.createElement("div", {
    className: "select single"
  }, /*#__PURE__*/React.createElement("select", Object.assign({}, k, {
    value: j,
    name: b,
    onChange: function onChange(a) {
      var b = a.target,
          c = b.name,
          d = b.value;
      "function" == typeof k.onChange && k.onChange({
        name: c,
        value: d
      }, a);
    }
  }), d.map(function (a, b) {
    var c = a.name,
        d = a.value,
        e = a.slug;
    return /*#__PURE__*/React.createElement("option", {
      key: b,
      value: d || e
    }, c);
  })));
};
export default Select;